import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import moment from 'moment';
import { getFinancialYears } from '../redux/actions/dashboard';
import { getLastPurchaseOrderDaybook } from '../redux/actions/purchaseOrder';

const usePurchaseOrderLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastPurchaseDaybook = useSelector((state) => state.purchaseOrder.lastPurchaseDaybook);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const financialYear = financialYears?.find((a) => a.financial_year === user?.financialYear);

   const getLastPurchaseDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         if (financialYear?.financial_year) {
            const fromDate = moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
            const toDate = moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
            const params = {
               companyId: user.loginhistory.companyId,
               fromDate,
               toDate,
               ...(selectedDaybookId && { daybookId: selectedDaybookId }),
            };
            await dispatch(getLastPurchaseOrderDaybook(params));
         } else {
            await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
         }
      }
   }, [dispatch, financialYear, selectedDaybookId, user]);

   useEffect(() => {
      getLastPurchaseDaybook();
   }, [getLastPurchaseDaybook]);

   return {
      lastPurchaseDaybook,
      setSelectedDaybookId,
   };
};

export default usePurchaseOrderLastDaybook;
